import { MetaData, MetaDataMapping } from "../../../models/meta-data.model";
import * as _ from "underscore";
import { Tag } from "../../../models/tag.model";
import { FamilyStatus } from "../../../models/patient.model";

export class BuildSearchDataHelper {
  public buildSummaryData(
    searchResults: any,
    tags: { [patientId: string]: Tag[] }
  ): any[] {
    const summaryData = [];
    for (const patient of searchResults.patient) {
      if (patient) {
        // build taglist column
        let tagList;
        if (tags[patient.patientId]) {
          for (let j = 0; j < tags[patient.patientId].length; j++) {
            if (
              tags[patient.patientId][j] &&
              tags[patient.patientId][j]["tags.name"]
            ) {
              let prefix;
              if (!tagList) {
                tagList = "";
                prefix = "";
              } else {
                prefix = ", ";
              }
              tagList =
                tagList + prefix + tags[patient.patientId][j]["tags.name"];
            }
          }
        }

        const summaryDataToAdd = {
          checkbox: "checkbox",
          dataType: "patient",
          iconType: [
            FamilyStatus.familyMember,
            FamilyStatus.probandWithFamily,
          ].includes(patient.familyStatus)
            ? "family"
            : "patient",
          patientId: patient.patientId,
          images: 0,
          metabolomics: 0,
          snp: 0,
          wes: 0,
          wgs: 0,
          tags: tagList,
        };

        const dataTypes = ["image", "genetic", "metabolomic"];
        const geneticFileTypes = ["snp", "wes", "wgs"];

        dataTypes.forEach((dataType) => {
          for (const data of searchResults[dataType]) {
            if (data.patientId === patient.patientId) {
              if (dataType === "genetic") {
                // split out genetic by file type for summary page
                data["metaDatas"].forEach((metaData: MetaData) => {
                  const metaDataMapping: MetaDataMapping =
                    metaData["metaDataMappings"][0];
                  if (metaDataMapping.columnId === "FILETYPE") {
                    summaryDataToAdd[metaData.value.toLowerCase()]++;
                  }
                });
              } else {
                summaryDataToAdd[dataType + "s"]++;
              }
            }
          }
        });

        summaryData.push(summaryDataToAdd);
      }
    }
    return _.uniq(summaryData, false, "patientId");
  }
}



// WEBPACK FOOTER //
// ./src/app/home/search/results/build-search-data.helper.ts